import { buildService } from './decorated-service';
import settings from '../../../settings.json';

const api = buildService(`/nasu-svc/service/v2/custodians`);

const mockCustodianByID = {
  csdId: 'a1s2g000000SOhKAAW',
  custodianName: 'Vanguard',
  fundFamilyName: 'Vanguard',
  regularAddressLine1: 'PO Box 1110',
  regularAddressLine2: null,
  regularAddressCity: 'Valley Forge',
  regularAddressState: 'PA',
  regularAddressZip: '19482',
  regularAddressZipExt: '',
  overnightAddressLine1: '455 Devon Park Dr',
  overnightAddressLine2: null,
  overnightAddressCity: 'Wayne',
  overnightAddressState: 'PA',
  overnightAddressZip: '19087',
  overnightAddressZipExt: '',
  customerServicePhone: '8006622739',
  toraParticipant: true,
  toraNumber: '5772',
  toraIneligibleCUSIPs: null,
  toraPhone: '8006622739',
  toraPreliquidation: false,
  msgRequired: false,
  msgDollarThreshold: 0,
  faxesAccepted: false,
  branchAddressRequired: true,
  faxNumber: '4845822806',
  eSignatureAccepted: false,
  transferTopInstitution: true,
  rolloverTopInstitution: true,
  funds: [
    {
      name: 'Vanguard Interm-Term Bond Index Inv',
      cusip: '921937306',
      symbolCode: 'VBIIX',
      providerId: 'FOUSA00BB1',
      externalId: '5521203'
    },
    {
      name: 'Vanguard Tax-Managed Balanced Adm',
      cusip: '921943304',
      symbolCode: 'VTMFX',
      providerId: 'FOUSA00BB5',
      externalId: '5521206'
    },
    {
      name: 'Vanguard LifeStrategy Income Inv',
      cusip: '921909206',
      symbolCode: 'VASIX',
      providerId: 'FOUSA00BCR',
      externalId: '5521242'
    },
    {
      name: 'Vanguard Instl Trgt Retire 2065 Instl',
      cusip: '92202E672',
      symbolCode: 'VSXFX',
      providerId: 'F00000YE50',
      externalId: '5531067'
    },
    {
      name: 'Vanguard Target Retirement 2065 Inv',
      cusip: '92202E680',
      symbolCode: 'VLXVX',
      providerId: 'F00000YE51',
      externalId: '5531069'
    },
    {
      name: 'Vanguard Intmdt-Term Trs Idx Instl',
      cusip: '92206C805',
      symbolCode: 'VIIGX',
      providerId: 'F000003Z3J',
      externalId: '5532317'
    },
    {
      name: 'Vanguard Instl Trgt Retire 2035 Instl',
      cusip: '92202E763',
      symbolCode: 'VITFX',
      providerId: 'F00000VE86',
      externalId: '5519141'
    }
  ],
  toraIneligibleFunds: false
};

export const getCustodianDetailsByIDService = async (
  custodianID
): Promise<any> => {
  if (settings['mockedMode']) return mockCustodianByID;
  return api.http.get(`/${custodianID}`);
};

export default api;
